import { Head, Link } from '@inertiajs/react'
import Form from './form.tsx'
import type { TaxTypeType } from './types.ts'

interface NewProps {
  tax_type: TaxTypeType
}

export default function New({ tax_type }: NewProps) {
  return (
    <>
      <Head title="Nouveau type de taxe" />

      <div className="mx-auto md:w-2/3 w-full px-8 pt-8">
        <h1 className="font-bold text-4xl">Nouveau type de taxe</h1>

        <Form
          tax_type={tax_type}
          method="post"
          action="/admin/tax_types"
          submitText="Créer un type de taxe"
        />

        <Link
          href="/tax_types"
          className="ml-2 rounded-lg py-3 px-5 bg-gray-100 inline-block font-medium"
        >
          Retour aux types de taxe
        </Link>
      </div>
    </>
  )
}
